export default {"src":"/_next/static/media/gcu-logo.83733755.svg","height":70,"width":350,"blurWidth":0,"blurHeight":0};